import React from 'react';
import type { PricingData } from '../hooks/usePricingData';
import { PricingValue } from './PricingValue';
interface PricingTableProps {
  data: PricingData;
}
export function PricingTable({
  data
}: PricingTableProps) {
  const {
    tiers,
    groups
  } = data;
  const highlightIndex = tiers.length === 3 ? 1 : -1;
  return <>
      {/* Desktop — full comparison matrix */}
      <div className="hidden lg:block" data-id="element-35" data-mp="332bltwrvfnze">
        <table className="w-full border-collapse" data-id="element-36" data-mp="3319yasto590s">
          <caption className="sr-only" data-id="element-37" data-mp="32zywuznp4dcu">
            Ari OS license comparison across {tiers.join(', ')}
          </caption>
          <thead className="sticky top-[70px] z-20" data-id="element-38" data-mp="3csmprjbk1x6a">
            <tr data-id="element-39" data-mp="3crbp3sdep5je">
              <th scope="col" className="w-[46%] bg-black/90 backdrop-blur-xl py-5 pr-6 text-left text-[11px] font-semibold uppercase tracking-[2px] text-zinc-600 border-b border-white/[0.12]" data-id="element-40" data-mp="3ctxsdft9kyvt">
                Compare licenses
              </th>
              {tiers.map((tier, index) => <th key={tier} scope="col" className="bg-black/90 backdrop-blur-xl py-5 px-4 text-center text-base font-semibold text-white border-b border-white/[0.12]" data-id="element-41" data-mp="31xkwhsiuhhii" data-mpi={index}>
                  {tier}
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-42" data-mp="3gvdagg8qtxul">
            {groups.map(group => <React.Fragment key={group.category || 'general'} data-id="element-43" data-mp="3kwf8itqxc3uz">
                {group.category && <tr data-id="element-44" data-mp="3ptovm2quc3fn">
                    <td colSpan={tiers.length + 1} className="pt-14 pb-4 text-[11px] font-semibold uppercase tracking-[2px] text-[#E9A165]" data-id="element-45" data-mp="3pt5q5lidn7ii">
                      {group.category}
                    </td>
                  </tr>}
                {group.features.map(row => <tr key={`${group.category}-${row.feature}`} className="border-t border-white/[0.07] group" data-id="element-46" data-mp="cfc58lv6x6ml">
                    <th scope="row" className="py-5 pr-10 text-left align-top font-normal" data-id="element-47" data-mp="29e3r1lpdls8w">
                      <span className="block text-[15px] text-white/90 group-hover:text-white transition-colors" data-id="element-48" data-mp="2i9l7cp0y0lln">
                        {row.feature}
                      </span>
                      {row.description && <span className="block text-[13px] text-zinc-500 mt-1 leading-relaxed max-w-xl" data-id="element-49" data-mp="2s92d16g72zhm">
                          {row.description}
                        </span>}
                    </th>
                    {row.values.map((value, index) => <td key={`${tiers[index]}-${index}`} className={`py-5 px-4 text-center align-top ${index === highlightIndex ? 'bg-white/[0.015]' : ''}`} data-id="element-50" data-mp="2x6kfcdzpiggn" data-mpi={index}>
                        <PricingValue value={value} data-id="element-51" data-mp="so2you74a2a4" />
                      </td>)}
                  </tr>)}
              </React.Fragment>)}
          </tbody>
        </table>
      </div>

      {/* Mobile — one block per license */}
      <div className="lg:hidden space-y-14" data-id="element-52" data-mp="iy1dqba28zzf">
        {tiers.map((tier, tierIndex) => <section key={tier} data-id="element-53" data-mp="nvtabilnha9y" data-mpi={tierIndex}>
            <h3 className="text-xl font-semibold text-white mb-1 tracking-tight" data-id="element-54" data-mp="903mrg0tgp34">
              {tier}
            </h3>
            <div className="h-px bg-white/[0.12]" data-id="element-55" data-mp="dzq15ssdsbdi" />
            {groups.map(group => <div key={`${tier}-${group.category || 'general'}`} data-id="element-56" data-mp="3w532hitzjqs2">
                {group.category && <p className="pt-8 pb-2 text-[11px] font-semibold uppercase tracking-[2px] text-[#E9A165]" data-id="element-57" data-mp="4y08ykqod8eo">
                    {group.category}
                  </p>}
                <dl data-id="element-58" data-mp="1zc9lgzq694r0">
                  {group.features.map(row => <div key={`${tier}-${row.feature}`} className="flex items-start justify-between gap-6 py-4 border-t border-white/[0.07]" data-id="element-59" data-mp="1zagns9xjduv5">
                      <dt data-id="element-60" data-mp="3qes0xuxjcg3y">
                        <span className="block text-[15px] text-white/90" data-id="element-61" data-mp="3lgyv53059o47">
                          {row.feature}
                        </span>
                        {row.description && <span className="block text-[13px] text-zinc-500 mt-1 leading-relaxed" data-id="element-62" data-mp="3cgjyx8ln6olx">
                            {row.description}
                          </span>}
                      </dt>
                      <dd className="flex-shrink-0 text-right pt-0.5" data-id="element-63" data-mp="32s202wwxarkx">
                        <PricingValue value={row.values[tierIndex]} align="right" data-id="element-64" data-mp="2xs76gllrjnw6" />
                      </dd>
                    </div>)}
                </dl>
              </div>)}
          </section>)}
      </div>
    </>;
}